import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import { Button } from "@mui/material";
import Stack from "@mui/material/Stack";

export interface DownloadButtonProps {
  onClickDownload: () => void;
}

export function DownloadButton({ onClickDownload }: DownloadButtonProps) {
  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <Button
        variant="outlined"
        size="small"
        startIcon={<DownloadRoundedIcon />}
        onClick={onClickDownload}
        sx={(theme) => ({
          "& .MuiButton-startIcon": {
            marginRight: "4px",
            marginLeft: "0px",
          },
          padding: "6px",
          textTransform: "none",
          fontFamily: '"Open Sans", sans-serif',
          fontSize: "13px",
          fontWeight: theme.typography.fontWeightSemiBold,
          borderColor: theme.palette.secondary.light,
          borderRadius: "4px",
          color: theme.palette.secondary.main,
          backgroundColor: theme.palette.support[50],

          "&:hover": {
            borderColor: theme.palette.secondary.light,
            backgroundColor: theme.palette.support[200],
          },
        })}
      >
        Descargar
      </Button>
    </Stack>
  );
}
